import {
    fromJS
} from 'immutable';
import * as constants from './constants';
import userRequest, {
    userApi
} from 'common/request';
import  {Link} from 'react-router-dom';
import React from 'react';
import axios from 'axios';
import { func } from 'prop-types';

export const changeHomeData = (data) => ({
    type: constants.CHANGE_HOME_DATA,
    data: fromJS(data)
});
export const changeSettingData = (data) =>({
    type:constants.CHANGE_SETTING_DATA,
    settingInfo:fromJS(data)
});
export const changeUserInfo = (data) =>({
    type: constants.CHANGE_USERINFO,
    userinfo: fromJS(data)
});
export const changeRegPhone = data => ({
  type: constants.CHANGE_REGPHONE,
  regneedphone: data
})
export const getSettingData = () =>{
    return (dispatch) => {
        userRequest.get('/set'+userApi.settingInfo,{
            tenant_code: localStorage.getItem('tenant_code')
        }).then((res)=>{
            if(res.success){
                dispatch(changeSettingData(res.data))
            }
        })
    }
}
export const getCourseList = (types, page, perpage) => {
    return (dispatch) => {
        userRequest.get(window.AppConfig.mainIP + userApi.courseList, {
            types: types || '',
            page: page || 1,
            'per-page': perpage || 12,
            live_status: 'all',
            tenant: localStorage.getItem('tenant_code')
        }).then((res) => {
            if (res.code === 0) {
                dispatch(changeHomeData(res.data))
                // console.log('res', res.data)
            }
        })
    }
}

async function getAuth(userinfo, dispatch) {
  return await axios.get(userApi.rentConfig, {params: {id: userinfo.tenant}}).then(res => {
    if(localStorage.getItem('userinfo') !== null){
      localStorage.removeItem('userinfo');
    }
    console.log(res)
    if(res.data.params.list[0].data.faceId.need == "no") {
      userinfo.need = "no"
      localStorage.setItem("userinfo",JSON.stringify(userinfo))
    }else {
      userinfo.need = "yes"
      localStorage.setItem("userinfo",JSON.stringify(userinfo))
    }
    dispatch(changeUserInfo(userinfo))
  }).catch(err => {
    console.log(err)
  })
}

export const setUserInfo = () => {
  return async dispatch => {
    await userRequest.get(window.AppConfig.mainIP + userApi.userInfo).then(res => {
      const params = res.params
      // if (params.verifyphone != 1) return window.location.href = `${window.AppConfig.loginUrl}?tenant_code=${localStorage.getItem("tenant_code")}`
      let userinfo = {
        user_name: params.account,
        user_id: params.id,
        structures: params.structures,
        tenant: params.tenant_id,
        realname: params.realname,
        verifyphone: params.verifyphone,
        faceAuth: params.faceAuth,
        sfzh: params.SFZH,
        account: params.account
      }
      if (navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1) dispatch(setRegPhone())
      // getAuth(userinfo, dispatch)
      localStorage.setItem("userinfo",JSON.stringify(userinfo))
      dispatch(changeUserInfo(userinfo))
  })
}}


 
export const setRegPhone = () => {
  return async (dispatch, getState) => {
    await userRequest.get(`/tenantauth?id=${localStorage.getItem("tenant_code")}`).then(res => {
      const regneedphone = res.params.list[0].data.regneedphone
      const verifyphone = getState().toJS().home.userinfo.verifyphone
      if (regneedphone && regneedphone != 4 && regneedphone != 1 && verifyphone !=1) return window.location.href = `${window.AppConfig.loginUrl}?tenant_code=${localStorage.getItem("tenant_code")}`
    })
  }
}

export const getUserInfo = () => {
   return (dispatch) => {
     let userinfo =JSON.parse(localStorage.getItem("userinfo")||"{}");
   }
}
